<template>
    <div class="wrapper-popup">
        <div class="popup-grid">
            <div class="info">
                <h3 class="info-item">{{ usr.first + ' ' + usr.last }}</h3>
                <p class="info-item">{{ usr.org }}</p>
                <p class="info-item title">{{ usr.title }}</p>
            </div>
            <div class="options">
                <div class="icon" v-if="showJoinButton" @click="joinConversation">
                    <MdContactsIcon/><span class="tooltip">Join a conversation with {{ usr.first }}</span>
                </div>
                <div class="icon" v-if="usr.profiles && usr.profiles.linkedin" @click="openUrl(usr.profiles.linkedin)">
                    <LogoLinkedinIcon/><span class="tooltip">LinkedIn</span>
                </div>
                <div class="icon" v-if="usr.profiles && usr.profiles.twitter" @click="openUrl(usr.profiles.twitter)">
                    <LogoTwitterIcon/><span class="tooltip">Twitter</span>
                </div>
            </div>
            <img :class="{'circle': true, 'loaded': imgLoaded}" :src="usr.img" @load="imgLoaded = true">
        </div>
    </div>
</template>

<script>
import MdContactsIcon from 'vue-ionicons/dist/md-contacts.vue'
import LogoLinkedinIcon from 'vue-ionicons/dist/logo-linkedin.vue'
import LogoTwitterIcon from 'vue-ionicons/dist/logo-twitter.vue'

import { auth } from '../../../db'

export default {
    name: 'UserPopup',
    props: ['usr', 'expoId'],
    components: {
        MdContactsIcon, LogoLinkedinIcon, LogoTwitterIcon
    },
    data() {
        return {
            imgLoaded: false,
        }
    },
    computed: {
        isYou() {
            if (auth.currentUser) {
                return auth.currentUser.uid == this.usr.uid
            } else {
                return 'unknown' == this.usr.uid
            }
        },
        showJoinButton() {
            return this.usr.currentRoom && this.usr.currentRoom.startsWith(this.expoId) && !this.isYou
        }
    },
    methods: {
        joinConversation() {
            if (this.usr.currentRoom.startsWith(this.expoId)) {
                if (this.$store.state.user.data) {
                    this.$router.push('/expo/' + this.usr.currentRoom)
                } else {
                    this.$router.push({ name: 'Log In', params: { routeAfter: '/expo/' + this.usr.currentRoom }})
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../interface.scss';
.wrapper-popup {
    position: absolute;
    top: -2px;
    right: -2px;
    padding: 20px;
    background-color: var(--other-color);
    border-radius: 16px 100px 100px 16px;
    border: 2px solid black;
    box-shadow: 0px 0px 2px var(--main-color);
    .popup-grid {
        position: relative;
        display: grid;
        row-gap: 10px;
        column-gap: 20px;
        grid-template-columns: auto auto;
        grid-template-rows: 60px 30px;
        height: 100px;
        .info {
            grid-area: 1 / 1 / 1 / 1;
            text-align: right;
            .info-item {
                margin: 0;
                margin-bottom: 2px;
                margin-left: auto;
                width: max-content;
                max-width: 250px;
                &.title {
                    font-weight: bold;
                }
            }
        }
        .options{
            grid-column: 1 / 1;
            display: flex;
            justify-content: flex-end;
            .submit {
                margin: 0;
            }
        }
        img.circle {
            grid-area: 1 / 2 / -1 / 2;
            height: 100px;
            width: 100px;
            background-color: transparent;
            box-shadow: 0 0 0 8px var(--main-color);
            transition: opacity 0.2s ease;
            opacity: 0;
            &.loaded {
                opacity: 1;
            }
        }
        .icon {
            position: relative;
            margin: 0 5px 0 5px;
            font-size: 30px;
            cursor: pointer;
            fill: var(--main-color);
            transition: fill 0.2s ease;
            &:hover {
                fill: var(--theme-color);
                .tooltip {
                    opacity: 1;
                }
            }
            .tooltip {
                opacity: 0;
                z-index: 70;
            }
            svg {
                width: 1em;
                height: 1em;
            }
        }
    }
}
</style>